import { ILocalization } from '../../../../../application/language/ILocalization';
import { ILearningMetricsModel } from '../../../../../service/report/interface/ILearningMetricsModel';

export type IMetricCard = {
  label: string;
  value: string | number;
  sub?: string;
  maxValue?: string | number;
  infoTooltip?: string;
};

export const mapToMetricsSectionData = (
  data: ILearningMetricsModel,
  { translate }: ILocalization,
  averageProgressLabelKey?: string,
): IMetricCard[] => [
  {
    label: translate(averageProgressLabelKey || 'learningReport.metrics.averageProgress.label'),
    value: `${data.averageProgress}%`,
  },
  {
    label: translate('learningReport.metrics.activeUsers.label'),
    value: String(data.activeUsersCount),
    maxValue: String(data.totalUsersCount),
    infoTooltip: translate('learningReport.metrics.activeUsers.tooltip'),
  },
  {
    label: translate('learningReport.metrics.completedUsers.label'),
    value: String(data.completedUsersCount),
    maxValue: String(data.totalUsersCount),
  },
];
